import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './i18n/config';
import Layout from './components/Layout';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Resume from './pages/Resume';
import Blog from './pages/Blog';
import Admin from './pages/Admin';
import Consultation from './pages/Consultation';

function App() {
  const { i18n } = useTranslation();
  
  // Normalize language to supported values (en, fr)
  const supported = ['en', 'fr'] as const;
  const detected = (i18n.language || 'en').slice(0, 2).toLowerCase();
  const currentLang = supported.includes(detected as any) ? detected : 'en';

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Redirect root to current language */}
          <Route path="/" element={<Navigate to={`/${currentLang}`} replace />} />
          
          {/* Language-specific routes */}
          <Route path= "/:lang" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<Home />} />
            <Route path="portfolio" element={<Portfolio />} />
            <Route path="contact" element={<Contact />} />
            <Route path="resume" element={<Resume />} />
            <Route path="blog" element={<Blog />} />
            <Route path="consultation" element={<Consultation />} />
          </Route>

          {/* Admin route (outside language scope) */}
          <Route path="/admin" element={<Admin />} />
          
          {/* Fallback for any unmatched routes */}
          <Route path="*" element={<Navigate to={`/${currentLang}`} replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;